import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setTotal } from '../../store/slices/stepBuilderSlice';

export const StepBuilderContext = React.createContext();

const StepBuilder = ({ children, totalSteps }) => {
  const dispatch = useDispatch();
  const { current, total } = useSelector(state => state.stepBuilder);

  useEffect(() => {
    if (totalSteps) {
      dispatch(setTotal(totalSteps));
    }
  }, [totalSteps, dispatch]);

  return (
    <StepBuilderContext.Provider value={{ current, total }}>
      {children}
    </StepBuilderContext.Provider>
  );
};

export default StepBuilder;